import { render, staticRenderFns } from "./answerInterAnalysis.vue?vue&type=template&id=24437e4d&scoped=true"
import script from "./answerInterAnalysis.vue?vue&type=script&lang=js"
export * from "./answerInterAnalysis.vue?vue&type=script&lang=js"
import style0 from "./answerInterAnalysis.vue?vue&type=style&index=0&id=24437e4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24437e4d",
  null
  
)

export default component.exports